query MobileDashboardMobileSdkTests(
	$offset: Int!
	$limit: Int!
	$sort: msdk_report_runsSort
	$daysAmountFilter: ConditionInt
	$customFieldsFilter: ConditionStringArray
	$customFieldsFilterExcludes: ConditionStringArray
	$msdkOsFilter: ConditionString
	$msdkAppFilter: ConditionString
) {
	msdk_report_runs(
		offset: $offset
		limit: $limit
		sort: $sort
		run_time_last_n_days: $daysAmountFilter
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
	) {
		run_id
		test_name
		total_issues
		critical_issues
		serious_issues
		run_time
		app_id
	}
	total: msdk_report_runs(
		run_time_last_n_days: $daysAmountFilter
		custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
		custom_fields_eq_any_item_for_any_value: $customFieldsFilter
		os_eq: $msdkOsFilter
		app_eq: $msdkAppFilter
	) {
		run_id_count
	}
	unfiltered_total: msdk_report_runs {
		run_id_count
	}
}
